import { useMemo } from "react";
import { getWidestLabelWidth } from "./measureTextWidth";

export const MIN_WIDTH = 200;
export const MAX_WIDTH = 480;
const CHROME_PADDING = 48;
const SAFETY_BUFFER = 12;
const DEFAULT_FONT = "400 16px Roboto, Helvetica, Arial, sans-serif";

const clamp = (value: number, min: number, max: number): number =>
  Math.min(Math.max(value, min), max);

export const useAutoSelectWidth = (
  labels: string[],
  opts?: { min?: number; max?: number; font?: string },
): string => {
  const min = opts?.min ?? MIN_WIDTH;
  const max = opts?.max ?? MAX_WIDTH;
  const font = opts?.font ?? DEFAULT_FONT;
  const labelsKey = labels.join("|");

  const width = useMemo(() => {
    const widest = getWidestLabelWidth(labels, font);
    return clamp(widest + CHROME_PADDING + SAFETY_BUFFER, min, max);
  }, [labelsKey, min, max, font]);

  return `${width}px`;
};
